<template>
  <div class="main-content">
    <div class="content-wrap no-bar">
      <div class="title">{{ text.title }}</div>
      <div class="title-tips mTop10 color-Gray_9e">{{ text.titleTip }}</div>
      <div class="rule-list">
        <ul>
          <li
            v-for="(rule, index) in $data[currentRuleArrKey]"
            :key="index"
            class="list-item"
            :class="{ active: currentRuleIdx === index }"
            @click="selectRule(index)"
          >
            <span class="index color-Gray_9e">{{ index + 1 }}、</span>
            <div class="main">
              <div
                v-if="['mutiUnique', 'reasonable'].includes(menu) && rule.name.length > 0"
                class="mBottom10 bold-text"
              >
                {{ rule.name }}
              </div>
              <div v-if="rule.cidList && rule.cidList.length != 0" class="cloumn mBottom10">
                {{ rule.cidList | getFieldText(fieldsMap) }}
              </div>
              <div class="color-Gray_9e">
                {{ rule.whenCreate ? text.newTip : text.conditionTip }}
              </div>
              <!-- <div class="cloumn">
                <span>结束日期</span>
                <span class="tip-text color-Gray_9e">{{ text.conditionTip }}</span>
              </div>
              <div class="cloumn" style="margin-top: 14px">
                <span class="mRight10">项目状态</span>
                <span class="mRight10">是</span>
                <span>已结束</span>
              </div> -->
            </div>
            <div class="operation color-Gray_9e">
              <i class="el-icon-delete-solid" @click.stop="deleteRule(index)"></i>
            </div>
          </li>
          <li class="add-box" @click="addRule">+ 添加新规则</li>
        </ul>
      </div>
    </div>
    <set-rules
      ref="setRules"
      class="set-rules no-bar"
      :menu="menu"
      :showConfig="currentRuleIdx != -1"
      :canConfigFields="canConfigFields"
      :sheetInfo="sheet"
      v-bind="$attrs"
    ></set-rules>
  </div>
</template>

<script>
import SetRules from "./set-rules"
import { rulesMap, getEmptyRules } from "./static"

export default {
  name: "main-content",
  components: {
    "set-rules": SetRules
  },
  data() {
    return {
      pageContent: rulesMap,
      ...getEmptyRules(),
      currentRule: {},
      currentRuleIdx: -1
    }
  },
  props: {
    menu: String,
    sheetFields: Array,
    sheet: Object
  },
  computed: {
    // 头部文字
    text() {
      return this.pageContent[this.menu] || {}
    },
    // 字段map {fieldCid: fieldName, ...}
    fieldsMap() {
      return this.sheetFields.reduce((acc, cur) => {
        acc[cur.value] = cur.label
        return acc
      }, {})
    },
    // 已经设置过的字段
    hasSetFields() {
      return this.$data[this.currentRuleArrKey].reduce((acc, rule) => {
        return acc.concat(rule.cidList)
      }, [])
    },
    // 当前可以设置的字段
    canConfigFields() {
      if (!this.currentRule || !this.currentRule.cidList) return []
      let fields = this.sheetFields.filter(field => field.type !== "chart")
      if (this.menu === "hide") {
        return fields
      }
      return fields.reduce((acc, field) => {
        // 在非当前rule里配置过的字段不能再配置
        if (
          this.currentRule.cidList.includes(field.value) ||
          !this.hasSetFields.includes(field.value)
        ) {
          acc.push(field)
        }
        return acc
      }, [])
    },
    // 当前正在设置规则的数组key
    currentRuleArrKey() {
      return `${this.menu}Rules`
    }
  },
  filters: {
    getFieldText(cidList, fieldsMap) {
      if (Object.keys(fieldsMap).length == 0) return ""
      return cidList.reduce((acc, cur) => {
        acc = acc + " " + fieldsMap[cur]
        return acc
      }, "")
    }
  },
  watch: {
    menu: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.currentRule = {}
          this.currentRuleIdx = -1
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化字段规则
    initial({ rules, uniqueRules, selfRules } = {}) {
      this.disabledRules = []
      this.hideRules = []
      this.requiredRules = []
      rules.forEach(rule => {
        if (rule.type == "DISABLE") {
          this.disabledRules.push(rule)
        } else if (rule.type == "HIDE") {
          this.hideRules.push(rule)
        } else if (rule.type === "REQUIRED") {
          this.requiredRules.push(rule)
        }
      })
      this.mutiUniqueRules = uniqueRules
      this.reasonableRules = selfRules
    },
    // 添加一个字段规则
    addRule() {
      let cidList = [],
        filters = []
      switch (this.menu) {
        case "disabled": {
          this.disabledRules.push({ cidList, filters, type: "DISABLE", whenCreate: false })
          break
        }
        case "hide": {
          this.hideRules.push({ cidList, filters, type: "HIDE", whenCreate: false })
          break
        }
        case "required": {
          this.requiredRules.push({ cidList, filters, type: "REQUIRED", whenCreate: false })
          break
        }
        case "mutiUnique": {
          this.mutiUniqueRules.push({ name: this.text.title, cidList, filters, whenCreate: false })
          break
        }
        case "reasonable": {
          this.reasonableRules.push({ name: this.text.title, filters })
          break
        }
      }
      this.$nextTick(() => {
        this.selectRule(this.$data[this.currentRuleArrKey].length - 1)
      })
    },
    // 删除一个字段规则
    deleteRule(index) {
      this.currentRuleIdx = -1
      this.$data[this.currentRuleArrKey].splice(index, 1)
    },
    // 选择一个字段规则
    selectRule(index) {
      if (this.currentRuleIdx == index) return
      this.currentRuleIdx = index
      if (index == -1) return
      this.currentRule = this.$data[this.currentRuleArrKey][index]
      this.$nextTick(() => {
        this.$refs.setRules.initial(this.currentRule)
      })
    },
    // 校验输出的内容
    verifyOutput() {
      let index = this.mutiUniqueRules.findIndex(i => !i.name)
      if (index != -1 && index !== undefined) {
        let msg = `多字段唯一规则里的第${index + 1}个规则的规则名为空！`
        this.$message.error(msg)
        return false
      }
      index = this.reasonableRules.findIndex(i => !i.name)
      if (index != -1 && index !== undefined) {
        let msg = `可保存规则里的第${index + 1}个规则的规则名为空！`
        this.$message.error(msg)
        return false
      }
      return true
    },
    // 输出所有字段规则
    output() {
      if (!this.verifyOutput()) return
      return Object.assign({}, this.sheet.data, {
        rules: this.disabledRules.concat(this.hideRules).concat(this.requiredRules),
        uniqueRules: this.mutiUniqueRules,
        selfRules: this.reasonableRules
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  height: calc(100vh - 55px);

  .content-wrap {
    flex: 1 1;
    padding: 24px 30px;
    box-sizing: border-box;
    overflow-y: scroll;

    .title {
      font-size: 16px;
    }

    .title-tips {
      font-size: 14px;
    }

    .rule-list {
      margin-top: 30px;

      li {
        cursor: pointer;

        &:hover {
          background-color: #e9f5fe;
        }
      }

      .list-item {
        display: flex;
        margin-bottom: 12px;
        padding: 20px 16px;
        font-size: 13px;
        background-color: #f7f7f7;
        border-radius: 4px;
        box-sizing: border-box;

        &.active {
          background-color: #e9f5fe;
        }

        .index {
          line-height: 18px;
        }

        .main {
          flex: 1 1;

          .tip-text {
            margin-left: 6px;
          }
        }

        .operation {
          .el-icon-delete-solid {
            padding: 2px;

            &:hover {
              color: #f44336;
            }
          }
        }
      }

      .add-box {
        height: 80px;
        border-radius: 4px;
        color: #2196f3;
        text-align: center;
        line-height: 80px;
        font-size: 14px;
        border: 1px dashed #ccc;

        &:hover {
          color: #0073ce;
          border: 1px dashed #2196f3;
        }
      }
    }
  }

  .set-rules {
    flex-basis: 500px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}
</style>
